import axios from '@/lib/axios';
import { useQuery } from '@tanstack/react-query';
import { WeeklySummary } from '@/hooks/api/models';
import queryClient from '@/lib/queryClient';

/**
 * 2390. 週次集計一覧取得
 * [GET] /workspaces/:identifier/weekly_summaries
 */
type Props = {
  identifier: string;
};

const weeklySummaries = (props: Props): Promise<WeeklySummary[]> => {
  return axios.get(`/api/workspaces/${props.identifier}/weekly_summaries`, { params: props });
};

export const useWeeklySummaries = (props: Props) => {
  return useQuery({
    queryKey: queryKey(props),
    queryFn: () => weeklySummaries(props),
  });
};

export const useInvalidateWeeklySummaries = (props: Props) => {
  const invalidate = async () => {
    await queryClient.invalidateQueries({ queryKey: queryKey(props) });
  };

  return { invalidate };
};

const queryKey = (props: Props) => {
  return ['workspaces', props.identifier, 'weekly_summaries'];
};
